/* ============================================================
   customizer.js – version "panier-ready"
   - Met à jour le mockup selon la variante
   - Sauvegarde la personnalisation dans le panier
   - Génère un aperçu JPEG compressé (_preview) pour le panier
   ============================================================ */

(function () {
  // ------------------ Utils ------------------
  const log = (...a) => console.log('[Customizer]', ...a);
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // ------------------ Éléments & état ------------------
  const els = {
    stage: null,        // grande zone blanche : #simple-stage (facultatif mais recommandé)
    mockup: null,       // l'image du mockup : #mockupImg
    textLayer: null,    // calque texte : #textLayer (optionnel)
    importImg: null     // calque image importée : #importImg (optionnel)
  };

  // État minimal de personnalisation (texte + image)
  const state = {
    text: {
      content: '',      // contenu texte (optionnel)
      x: 0.5,           // position (0..1) relative à la largeur
      y: 0.5,           // idem hauteur
      size: 32,         // en px "visuels" (convertis pour le preview)
      color: '#111111',
      font: 'Arial',
      bold: false,
      rot: 0
    },
    image: {
      present: false,   // vrai si un design importé est affiché
      x: 0.5,
      y: 0.5,
      scale: 1.0,       // échelle relative à la zone d’affichage
      rot: 0,
      opacity: 1
    }
  };

  // ------------------ Product JSON & variantes ------------------
  function getProductJSON() {
    try {
      const tag = document.getElementById('ProductJSON');
      if (!tag) return null;
      return JSON.parse(tag.textContent || '{}');
    } catch (e) {
      console.warn('[Customizer] ProductJSON invalide', e);
      return null;
    }
  }

  function getCurrentVariantId() {
    // 1) radio
    const r = $('input[name="id"][type="radio"]:checked');
    if (r && r.value) return Number(r.value);

    // 2) select
    const s = $('select[name="id"]');
    if (s && s.value) return Number(s.value);

    // 3) URL ?variant=xxxx
    const v = new URLSearchParams(location.search).get('variant');
    if (v) return Number(v);

    // 4) input hidden (certains thèmes le maintiennent)
    const hid = $('input[name="id"]');
    if (hid && hid.value) return Number(hid.value);

    return null;
  }

  function getVariantImageUrl(variant, product) {
    if (!variant || !product) return null;

    // OS 2.0 classique
    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    // Fallbacks selon thèmes
    if (product.featured_image) return product.featured_image;
    if (Array.isArray(product.images) && product.images.length) {
      return product.images[0];
    }

    return null;
  }

  function applyMockupImage(url) {
    if (!url || !els.mockup) return;
    els.mockup.src = url;
    els.mockup.removeAttribute('srcset');
    els.mockup.removeAttribute('data-src');
    els.mockup.setAttribute('loading', 'eager');

    // Si un conteneur utilise un background-image (selon le thème)
    const box = els.mockup.closest('.product__media') || els.mockup.closest('#simple-stage');
    if (box) {
      box.style.setProperty('--image', `url("${url}")`);
      box.style.backgroundImage = `url("${url}")`;
      box.style.backgroundSize = 'contain';
      box.style.backgroundRepeat = 'no-repeat';
      box.style.backgroundPosition = 'center center';
    }
  }

  function updateMockupFromVariant(product) {
    const id = getCurrentVariantId();
    if (!id) return;

    const variant = product.variants?.find(v => Number(v.id) === id);
    if (!variant) return;

    const url = getVariantImageUrl(variant, product);
    if (url) applyMockupImage(url);
  }

  function bindVariantChange(product) {
    const onChange = () => updateMockupFromVariant(product);

    // natifs
    document.addEventListener('change', (e) => {
      const t = e?.target;
      if (!t) return;
      if (t.matches('input[name="id"], input[name="id"][type="radio"], select[name="id"], [name^="options"]')) {
        onChange();
      }
    });

    // événements custom fréquents
    window.addEventListener('variant:changed', onChange);
    window.addEventListener('shopify:variant:change', onChange);
    window.addEventListener('popstate', onChange);

    // en cas de re-render des variantes
    const mo = new MutationObserver(() => {
      if ($('input[name="id"], select[name="id"], [name^="options"]')) onChange();
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // initial
    onChange();
  }

  // ------------------ Formulaire panier & propriétés ------------------
  function findProductForm() {
    return document.querySelector('form[action="/cart/add"]');
  }

  function ensureHiddenPropertyInputs(form) {
    if (!form) return {};
    let p1 = form.querySelector('input[name="properties[_customizer]"]');
    let p2 = form.querySelector('input[name="properties[_preview]"]');
    if (!p1) {
      p1 = document.createElement('input');
      p1.type = 'hidden';
      p1.name = 'properties[_customizer]';
      form.appendChild(p1);
    }
    if (!p2) {
      p2 = document.createElement('input');
      p2.type = 'hidden';
      p2.name = 'properties[_preview]';
      form.appendChild(p2);
    }
    return { propCustomizer: p1, propPreview: p2 };
  }

  function buildCustomizationPayload() {
    return {
      v: getCurrentVariantId(),
      mockup: els.mockup?.src || '',
      t: { ...state.text },
      i: {
        present: state.image.present,
        x: state.image.x,
        y: state.image.y,
        scale: state.image.scale,
        rot: state.image.rot,
        opacity: state.image.opacity
      },
      ts: Date.now()
    };
  }

  // Aperçu compressé pour le panier (JPEG)
  async function makePreviewDataURL(maxW = 700) {
    if (!els.mockup) return '';

    // attendre le mockup si besoin
    if (!els.mockup.complete || !els.mockup.naturalWidth) {
      await new Promise(res => { els.mockup.onload = res; });
    }

    const W = els.mockup.naturalWidth || 1200;
    const H = els.mockup.naturalHeight || 1200;
    const scale = Math.min(1, maxW / W);
    const PW = Math.round(W * scale);
    const PH = Math.round(H * scale);

    const cvs = document.createElement('canvas');
    cvs.width = PW; cvs.height = PH;
    const ctx = cvs.getContext('2d');

    // fond mockup
    ctx.drawImage(els.mockup, 0, 0, PW, PH);

    // image importée (si présente)
    if (state.image.present && els.importImg?.complete) {
      try {
        const r = els.stage?.getBoundingClientRect?.() || { width: PW, height: PH };
        const cx = state.image.x * PW;
        const cy = state.image.y * PH;
        const screenScaleToPx = (PW / (r.width || PW));
        const imgScale = state.image.scale * screenScaleToPx;

        ctx.save();
        ctx.globalAlpha = state.image.opacity;
        ctx.translate(cx, cy);
        ctx.rotate(state.image.rot * Math.PI / 180);
        ctx.scale(imgScale, imgScale);

        const iw = els.importImg.naturalWidth;
        const ih = els.importImg.naturalHeight;
        ctx.drawImage(els.importImg, -iw / 2, -ih / 2, iw, ih);
        ctx.restore();
      } catch (e) {
        console.warn('preview image layer failed', e);
      }
    }

    // calque texte (si présent)
    if (state.text.content) {
      try {
        const r = els.stage?.getBoundingClientRect?.() || { width: PW, height: PH };
        const cx = state.text.x * PW;
        const cy = state.text.y * PH;
        const fontPx = state.text.size * (PW / (r.width || PW));
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(state.text.rot * Math.PI / 180);
        ctx.fillStyle = state.text.color || '#111';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = `${state.text.bold ? '700 ' : ''}${Math.round(fontPx)}px ${state.text.font || 'Arial'}`;
        ctx.fillText(state.text.content, 0, 0);
        ctx.restore();
      } catch (e) {
        console.warn('preview text layer failed', e);
      }
    }

    // JPEG qualité 0.75 pour alléger
    return cvs.toDataURL('image/jpeg', 0.75);
  }

  function attachCartProperties() {
    const form = findProductForm();
    if (!form) { log('Form /cart/add introuvable'); return; }

    const { propCustomizer, propPreview } = ensureHiddenPropertyInputs(form);

    async function updateProps() {
      try {
        const payload = buildCustomizationPayload();
        if (propCustomizer) propCustomizer.value = JSON.stringify(payload);

        const previewUrl = await makePreviewDataURL(700);
        if (propPreview) propPreview.value = previewUrl;
      } catch (e) {
        console.warn('Update properties failed', e);
      }
    }

    // MAJ fréquentes (si thème AJAX)
    ['input', 'change'].forEach(ev => {
      document.addEventListener(ev, () => { updateProps(); }, { passive: true });
    });

    // juste avant l’envoi
    form.addEventListener('submit', async () => {
      await updateProps();
    });

    // initial
    updateProps();
  }

  // ------------------ Lecture DOM optionnelle (text/import) ------------------
  function readOptionalLayers() {
    // Texte : si un calque #textLayer existe, on l’utilise pour hydrater state.text.content
    if (els.textLayer) {
      const txt = els.textLayer.textContent?.trim() || '';
      if (txt) state.text.content = txt;
    }
    // Image importée : si #importImg est présent et a un src valide
    if (els.importImg && els.importImg.src) {
      state.image.present = true;
    }
  }

  // ------------------ GO ------------------
  document.addEventListener('DOMContentLoaded', () => {
    // Récup des éléments (certains peuvent ne pas exister encore)
    els.stage     = $('#simple-stage');
    els.mockup    = $('#mockupImg');
    els.textLayer = $('#textLayer');
    els.importImg = $('#importImg');

    readOptionalLayers();

    // Variantes → mockup
    const product = getProductJSON();
    if (product) {
      bindVariantChange(product);
    } else {
      log('ProductJSON non trouvé (ok si customizer sur page non-produit)');
    }

    // Attacher les line item properties au panier
    attachCartProperties();

    log('Prêt (customizer + panier)');
  });
})();

